import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { api } from '../../../shared/api/http'

interface OrderItem {
  id: number
  runner_id: number
  event_id: number
  companion_id?: number
  status: string
  price: number
  created_at: string
}

const OrdersListPage: React.FC = () => {
  const [items, setItems] = useState<OrderItem[]>([])
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    api.get<OrderItem[]>('/orders')
      .then(res => { setItems(res); setError('') })
      .catch(e => setError(e?.message || '加载失败'))
      .finally(() => setLoading(false))
  }, [])

  if (loading) return <div className="p-4">加载中...</div>
  if (error) return <div className="p-4 text-red-600">{error}</div>
  if (items.length === 0) return <div className="p-4">暂无订单</div>

  return (
    <div className="p-4">
      <h1 className="text-xl font-semibold mb-4">订单列表</h1>
      <ul className="space-y-2">
        {items.map(o => (
          <li key={o.id} className="p-3 border rounded">
            <Link className="text-orange-600" to={`/orders/${o.id}`}>订单 #{o.id}</Link>
            <div className="text-sm text-gray-500">状态：{o.status} · 金额：{o.price}</div>
          </li>
        ))}
      </ul>
    </div>
  )
}

export default OrdersListPage

